import { ErrorHandler, Injectable, Injector, inject } from '@angular/core';
import { isChunkLoadError } from './chunk-load-error';
import { StaleBundleRecoveryService } from './stale-bundle-recovery.service';

/**
 * Catches failed dynamic imports that do not surface through the router — and the
 * router's own re-throw, which reaches the global `ErrorHandler` as an unhandled
 * rejection. Everything else falls through to Angular's default console logging.
 */
@Injectable()
export class StaleBundleErrorHandler extends ErrorHandler {
  /**
   * Resolved lazily, on purpose. Angular's `errorHandlerEnvironmentInitializer`
   * calls `inject(ErrorHandler)` while the environment injector is still
   * initialising, so this class is constructed during bootstrap; injecting
   * MatDialog (and with it the CDK overlay) as a field would pull that whole
   * graph into bootstrap and risks a cyclic provider error.
   */
  private injector = inject(Injector);

  override handleError(error: unknown): void {
    if (isChunkLoadError(error)) {
      this.injector.get(StaleBundleRecoveryService).recover();
      return;
    }

    super.handleError(error);
  }
}
